import { render, staticRenderFns } from "./ProjectHistory.vue?vue&type=template&id=ccca521a&scoped=true&lang=pug"
import script from "./ProjectHistory.vue?vue&type=script&lang=js"
export * from "./ProjectHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccca521a",
  null
  
)

export default component.exports